<!-- TODO: A supprimer quand l'implémentation v10 sera terminée -->
<custom-frame [frame]="'ordonnanceur'" [isTitleHidden]="true"></custom-frame>
